if (!customElements.get('auyol-pdp-media-badges')) {
  customElements.define('auyol-pdp-media-badges', class extends HTMLElement {
    connectedCallback() {
      const ids = JSON.parse(this.dataset.variantIds);
      this.updateBadge = event => {
        const variant = event.detail?.variant;
        if (!variant || !ids.includes(variant.id)) return;
        const badge = this.querySelector('.auyol-pdp-saving');
        badge.hidden = !(variant.compare_at_price > variant.price);
        badge.textContent = badge.hidden ? '' : `${Math.round((1 - variant.price / variant.compare_at_price) * 100)}% SAVINGS`;
      };
      document.addEventListener('variant:changed', this.updateBadge);
    }
    disconnectedCallback() { document.removeEventListener('variant:changed', this.updateBadge); }
  });
}
